<template>
    <div>
        <div>
            <div class="form-check-label mt-3" style="padding: 10px 4px 0px 24px; border-radius: 16px">
                <div class="d-flex align-items-center space-between row pstr-resp">
                    <div class="w-100 col-6">
                        <v-select
                            :items="clientCards"
                            :label="$t('checkout.payment_stripe.card_label')"
                            single-line
                            solo
                            dense
                            hide-details
                            v-model="selectCard"
                            class="rounded-12 ppv2-text-black py-0 border-solid-db"
                        >
                            <template #no-data>
                                <div style="padding: 8px">{{ $t('checkout.payment_stripe.no_results') }}</div>
                            </template>
                            <template #item="{ item }">
                                <span> ****-****-****-{{ item.ending }} </span>
                            </template>
                            <template #selection="{ item }">
                                <span> ****-****-****-{{ item.ending }} </span>
                            </template>
                        </v-select>
                    </div>

                    <div class="col-6 d-flex justify-content-end">
                        <AddNewPaymentCard
                            v-model="showAddCardDialog"
                            :isInPopup="true"
                            :userId="userId"
                            :stripeKey="stripeKey"
                            @add-new-card="newCardAdded"
                            @close-modal="closeCardModal"
                        />
                    </div>
                </div>

                <span style="margin-left: 10px; color: red" v-if="errorPrelever">{{ errorPrelever }}</span>

                <div class="d-flex justify-content-between clientCards row mt-0 align-items-center mb-1 align-items-baseline">
                    <!--<v-select
                        :items="clientCards"
                        label="Carte de paiment"
                        single-line
                        solo
                        dense
                        hide-details
                        v-model="selectCard"
                        style="max-width: 400px"
                    >
                        <template #no-data>
                            <div style="padding: 8px">Aucun résultat</div>
                        </template>
                        <template #item="{ item }">
                            <span> ****-****-****-{{ item.ending }} </span>
                        </template>
                        <template #selection="{ item }">
                            <span> ****-****-****-{{ item.ending }} </span>
                        </template>
                    </v-select>-->
                    <div class="d-flex col-lg-6 col-md-6 col-sm-6 col-xs-12 p-0">
                        <div class="d-flex justify-content-between px-2 w-100">
                            <input
                                type="number"
                                class="form-control form-control-sm disabled bg-transparent h-40 w-100 px-3"
                                min="1"
                                :max="maxAmount"
                                v-model="amount"
                            />
                            <span class="text-grey my-auto mx-auto" style="margin-left: -61px !important">{{
                                $t('checkout.payment_stripe.currency_suffix', { currency: $symbolCurrency })
                            }}</span>
                        </div>

                        <span class="text-danger fs-sm pb-3 ps-3" v-if="isErrors">{{ amountError }}</span>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 d-flex justify-content-end justify-content-xs-start">
                        <v-btn
                            type="button"
                            style="
                                text-transform: none;
                                background: var(--Navy, #021832) !important;
                                border-radius: 8px;
                                box-shadow: 0px 8px 24px 0px rgba(98, 194, 246, 0.08);
                                color: #fff !important;
                                font-size: 12px;
                                height: 40px;
                                width: 190px;
                            "
                            class=""
                            :disabled="!selectCard || !amount || amount <= 0 || isErrors"
                            @click="prelever"
                            :loading="loadingPreleve"
                            color="#fff"
                        >
                            {{ $t('checkout.payment_stripe.collect') }}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="65.5px"
                                height="41px"
                                viewBox="0 -149 512 512"
                                version="1.1"
                                preserveAspectRatio="xMidYMid"
                            >
                                <g>
                                    <path
                                        d="M35.9822222,83.4844444 C35.9822222,77.9377778 40.5333333,75.8044444 48.0711111,75.8044444 C58.88,75.8044444 72.5333333,79.0755556 83.3422222,84.9066667 L83.3422222,51.4844444 C71.5377778,46.7911111 59.8755556,44.9422222 48.0711111,44.9422222 C19.2,44.9422222 0,60.0177778 0,85.1911111 C0,124.444444 54.0444444,118.186667 54.0444444,135.111111 C54.0444444,141.653333 48.3555556,143.786667 40.3911111,143.786667 C28.5866667,143.786667 13.5111111,138.951111 1.56444444,132.408889 L1.56444444,166.257778 C14.7911111,171.946667 28.16,174.364444 40.3911111,174.364444 C69.9733333,174.364444 90.3111111,159.715556 90.3111111,134.257778 C90.1688889,91.8755556 35.9822222,99.4133333 35.9822222,83.4844444 Z M132.124444,16.4977778 L97.4222222,23.8933333 L97.28,137.813333 C97.28,158.862222 113.066667,174.364444 134.115556,174.364444 C145.777778,174.364444 154.311111,172.231111 159.004444,169.671111 L159.004444,140.8 C154.453333,142.648889 131.982222,149.191111 131.982222,128.142222 L131.982222,77.6533333 L159.004444,77.6533333 L159.004444,47.36 L131.982222,47.36 L132.124444,16.4977778 Z M203.235556,57.8844444 L200.96,47.36 L170.24,47.36 L170.24,171.804444 L205.795556,171.804444 L205.795556,87.4666667 C214.186667,76.5155556 228.408889,78.5066667 232.817778,80.0711111 L232.817778,47.36 C228.266667,45.6533333 211.626667,42.5244444 203.235556,57.8844444 Z M241.493333,47.36 L277.191111,47.36 L277.191111,171.804444 L241.493333,171.804444 L241.493333,47.36 Z M241.493333,36.5511111 L277.191111,28.8711111 L277.191111,0 L241.493333,7.53777778 L241.493333,36.5511111 Z M351.431111,44.9422222 C337.493333,44.9422222 328.533333,51.4844444 323.555556,56.0355556 L321.706667,47.2177778 L290.417778,47.2177778 L290.417778,213.048889 L325.973333,205.511111 L326.115556,165.262222 C331.235556,168.96 338.773333,174.222222 351.288889,174.222222 C376.746667,174.222222 399.928889,153.742222 399.928889,108.657778 C399.786667,67.4133333 376.32,44.9422222 351.431111,44.9422222 Z M342.897778,142.933333 C334.506667,142.933333 329.528889,139.946667 326.115556,136.248889 L325.973333,83.4844444 C329.671111,79.36 334.791111,76.5155556 342.897778,76.5155556 C355.84,76.5155556 364.8,91.0222222 364.8,109.653333 C364.8,128.711111 355.982222,142.933333 342.897778,142.933333 Z M512,110.08 C512,73.6711111 494.364444,44.9422222 460.657778,44.9422222 C426.808889,44.9422222 406.328889,73.6711111 406.328889,109.795556 C406.328889,152.604444 430.506667,174.222222 465.208889,174.222222 C482.133333,174.222222 494.933333,170.382222 504.604444,164.977778 L504.604444,136.533333 C494.933333,141.368889 483.84,144.355556 469.76,144.355556 C455.964444,144.355556 443.733333,139.52 442.168889,122.737778 L511.715556,122.737778 C511.715556,120.888889 512,113.493333 512,110.08 Z M441.742222,96.5688889 C441.742222,80.4977778 451.555556,73.8133333 460.515556,73.8133333 C469.191111,73.8133333 478.435556,80.4977778 478.435556,96.5688889 L441.742222,96.5688889 L441.742222,96.5688889 Z"
                                        fill="#6772E5"
                                    ></path>
                                </g>
                            </svg>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.clientCards .v-input__slot {
    border-radius: 24px;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent !important;
    border-radius: 12px !important;
    border: 1px solid #e2e8f0 !important;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 40px !important;
    border-radius: 12px !important;
}
</style>
<script>
import axios from 'axios'

export default {
    props: ['userId', 'orderId', 'maxAmount', 'stripeKey'],
    mounted() {
        this.getClientCards()
    },
    components: {
        AddNewPaymentCard: () => import('./AddNewCard.vue'),
    },

    data: () => {
        return {
            showAddCardDialog: false,
            cartNum: null,
            expire: null,
            cvv: null,
            valid: false,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            isErrors: false,
            amount: 0,
            rules: {
                valid_num_cart: (value) => {
                    const pattern = /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/
                    return (
                        pattern.test(value) ||
                        this.$t('checkout.payment_stripe.wrong_format', { format: '(XXXX-XXXX-XXXX-XXXX)' })
                    )
                },
                valid_expire: (value) => {
                    const pattern = /^[0-9]{2}\/[0-9]{2}$/
                    return pattern.test(value) || this.$t('checkout.payment_stripe.wrong_format', { format: '(MM/YY)' })
                },
                valid_cvv: (value) => {
                    const pattern = /^[0-9]{3}$/
                    return pattern.test(value) || this.$t('checkout.payment_stripe.wrong_format', { format: '(XXX)' })
                },
                required: (value) => !!value || this.$t('checkout.payment_stripe.required'),
            },
        }
    },
    watch: {
        cartNum(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('-', ''), '-', 4, 3)
            if (newFormat.length > 19) newFormat = newFormat.substring(0, 19)

            if (val === newFormat) return

            this.cartNum = newFormat
        },
        expire(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('/', ''), '/', 2, 1)
            if (newFormat.length > 5) newFormat = newFormat.substring(0, 5)

            if (val === newFormat) return

            this.expire = newFormat
        },
        amount(val) {
            if (parseFloat(val) > parseFloat(this.maxAmount)) {
                this.isErrors = true
                this.amountError = this.$t('checkout.payment_stripe.rest_is', { amount: this.maxAmount, currency: '$' })
            } else {
                this.isErrors = false
                this.amountError = ''
            }
        },
    },
    methods: {
        insertAfterEveryN(str, char, n, res) {
            const result = str.split('').reduce((accumulator, current, index) => {
                if (index % n === res) {
                    return accumulator + current + char
                }

                return accumulator + current
            }, '')

            return result
        },
        async getClientCards() {
            if (this.userId === 0) return
            await axios.get(`/back-office/caisse/getPaymentMethod/${this.userId}`).then((res) => {
                this.clientCards = res.data
            })
        },
        async prelever() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByStripe`,
                    {
                        montant: this.amount,
                        userId: this.userId,
                        orderId: this.orderId,
                        cartId: this.selectCard.id,
                    },
                    { withCredentials: true }
                )
                .then(() => {
                    window.location.reload()
                })
                .catch((error) => {
                    this.errorPrelever = error?.response?.data?.message || this.$t('checkout.payment_stripe.error')
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
        async addClientCard() {
            this.loadingAddCart = true
            await axios
                .post(
                    `/back-office/customer/${this.userId}/payment/updatePaymentMethode`,
                    {
                        card_number: `${this.cartNum}`.replaceAll('-', ''),
                        card_date: `${this.expire}`,
                        card_cvc: `${this.cvv}`,
                    },
                    { withCredentials: true }
                )
                .then((res) => {
                    this.showAddCardDialog = false
                    this.getClientCards()
                })
                .finally(() => {
                    this.loadingAddCart = false
                })
        },
        newCardAdded() {
            this.getClientCards()
        },
        closeCardModal() {
            this.showAddCardDialog = false
            this.getClientCards()
        },
    },
}
</script>
